import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

export default function Sliders() {
  const allSliders = document.querySelectorAll('.swiper-container');
  const allMobileSliders = document.querySelectorAll('.swiper-container-mobile');
  const defaultSettings = {
    slidesPerView: 1,
  };

  const allSwipers = [];

  if (allSliders.length) {
    for (const curr of allSliders) {
      const settings = typeof curr.dataset.sliderSettings != 'undefined' ? JSON.parse(curr.dataset.sliderSettings) : defaultSettings;

      settings.modules = [Autoplay, Pagination, Navigation];

      allSwipers.push(new Swiper(curr, settings));
    }
  }

  if (allMobileSliders.length) {
    const mobileMediaQuery = window.matchMedia('(max-width: 992px)');

    const handleMobileSliders = () => {
      if (mobileMediaQuery.matches) {
        for (const curr of allMobileSliders) {
          const settings = typeof curr.dataset.sliderSettings != 'undefined' ? JSON.parse(curr.dataset.sliderSettings) : defaultSettings;

          settings.modules = [Autoplay, Pagination, Navigation];

          allSwipers.push(new Swiper(curr, settings));
        }
      } else {
        allSwipers.forEach((el) => el.destroy());
      }
    };

    handleMobileSliders();

    mobileMediaQuery.addEventListener('change', handleMobileSliders);
  }
}
